<template>
<div class="admin-account">
  
  <el-row>
    <el-col :span="isGeneralAdmin || hasFilter ? 12 : 24">
      <organization-breadcrumb :items="[$t('menu.account')]" />
    </el-col>
    <el-col v-if="isGeneralAdmin || hasFilter" :span="12">
        <admin-organization-switcher/>
    </el-col>
  </el-row>
  <el-container class="organization-container">
    <div v-if="fromAdmin" class="heading">
      <div class="org-info">
       <h1>
          {{ $t('account.account_detail') }}
        </h1>
      </div>
    </div>
    <div class="content">
      <div class="">
      <el-menu
        v-show="showOrganizationNav"
        :default-active="activeComponent"
        @select="onMenuChange"
        ref="menu"
        mode="horizontal"
        class="sidemenu"
        :empty-text="$t('common.no_values')"
      >
        <el-menu-item index="profile">
          <span>{{ $t('organization_page.menu.profile') }}</span>
        </el-menu-item>
        <el-menu-item index="contract" v-if="getOrganizationData && getOrganizationData.payment && getOrganizationData.payment.plan_details && getOrganizationData.payment.plan_details.length>0">
          <span>{{ $t('organization_page.menu.contract') }}</span>
        </el-menu-item>
        <el-menu-item index="admins">
          <span>{{ $t('organization_page.menu.admins') }}</span>
        </el-menu-item>
      </el-menu>
      </div>
      <div id="component-wrapper">
        <component
          :is="activeComponent"
          :organization="getOrganizationData"
          :organizationId="getOrganizationData.id"
          :fromAdmin="fromAdmin"
          :usersModifiers="usersModifiers"
          v-on:toggle-organization-nav="toggleOrganizationNav"
          v-on:invite-users="handleInviteUsersEvent"
          :inviteUsers="handleInviteUsers"
          :selectRolesAvailable="true"
        />
      </div>
    </div>
  </el-container>
</div>
</template>

<script>
  import Users from '@/components/organizations/Users'
  import Contract from '@/components/organizations/Contracts'
  import Admins from '@/components/organizations/Admins'
  import Groups from '@/components/organizations/Groups'
  import Profile from '@/components/organizations/Profile'
  import BackToList from '@/components/common/BackToList'
  import ImportUsers from '@/components/organizations/invites/ImportUsers'
  import EmailInvite from '@/components/organizations/invites/EmailInvite'
  import ShareLink from '@/components/organizations/invites/ShareLink'
  import UsersIcon from '@/assets/images/inline.users-icon.svg';
  import StudentsIcon from '@/assets/images/inline.students.svg';
  import TeachersIcon from '@/assets/images/inline.teachers.svg';
  import AdminsIcon from '@/assets/images/inline.admins.svg';
  import GroupsIcon from '@/assets/images/inline.groups-icon.svg';
  import ProfileIcon from '@/assets/images/inline.profile-icon.svg';
  import { mapGetters } from 'vuex'
  import { includes } from 'ramda'
  import OrganizationBreadcrumb from "@/components/common/OrganizationBreadcrumb";
  import AdminOrganizationSwitcher from "@/components/dashboard/AdminOrganizationSwitcher";

  export default {
    components: {
      Groups,
      GroupsIcon,
      Contract,
      Admins,
      Profile,
      ProfileIcon,
      UsersIcon,
      Users,
      StudentsIcon,
      TeachersIcon,
      AdminsIcon,
      BackToList,
      ImportUsers,
      ShareLink,
      EmailInvite,
      OrganizationBreadcrumb,
      AdminOrganizationSwitcher
    },
    mounted() {
      this.$store.dispatch('user/loadUserData')
      if(this.tab === 'admins') {
        this.activeComponent = 'admins'
      } else if (this.tab === 'contract') {
        this.activeComponent = 'contract'
      } else {
        this.activeComponent = 'profile'
      }
    },
    props: {
      fromAdmin: {
        type: Boolean,
        default: false
      },
      organizationId: {
        default: null
      },
      tab: {
        type: String,
        default: null,
      }
    },
    data() {
      return {
        activeComponent: 'profile',
        usersModifiers: null,
        showOrganizationNav: true,
      }
    },
    methods: {
      handleInviteUsers(emails, role, consent) {
        return this.$store.dispatch('invite/inviteUsers', {
          organizationId: this.getOrganizationData.id,
          role,
          emails,
          consent
        })
      },
      onMenuChange(index) {
        if(includes(index, ['student', 'teacher', 'admin'])) {
          this.usersModifiers = index
          this.activeComponent = 'users'
          return
        }

        this.activeComponent = index
        this.usersModifiers = null
      },
      backToList() {
        this.$router.push({
          path: `/admin/`
        })
      },
      handleInviteUsersEvent (component) {
        this.activeComponent = component
      },
      toggleOrganizationNav(visibility) {
        this.showOrganizationNav = visibility
      },

    },
    computed: {
      getOrganizationData () {
        const storedOrganization = this.fromAdmin ? this.$store.state.admin.currentOrganization : this.$store.getters['organization/currentOrganization']

        return storedOrganization
      },
      ...mapGetters('organization', [
        'isOrganizationAdmin',
        'isOrganizationAssociateAdmin',
        'isGeneralAdmin',
        'hasFilter'
      ])
    },
    watch: {
      organizationId: {
        immediate: true,
        handler(newOrganizationId) {
          if (!this.fromAdmin) {
            const organizationId = newOrganizationId
            this.$store.dispatch('organization/setCurrentOrganization', { organizationId })
            this.$store.dispatch('organization/getUserOrganizationData', { organizationId, userId: this.$store.getters['user/getUserId'] })
            // this.$store.dispatch('contracts/getCurrentPaymentContract', {organizationId})
            this.activeComponent = 'profile'
          }
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '../scss/_colors.scss';
  .admin-account {
    width: 100%;
  }
  .heading {
    margin-bottom: 32px;
    // margin-left: 20px;
    .org-info {
      display: flex;
    }
    h1 {
      border: none;
      display: flex;
      align-items: center;
      font-weight: 600;
      font-size: 32px;
      line-height: 48px;
      color: #121131;
    }
  }

  .organization-container {
    padding: 40px 16px;
    flex-direction: column;
    width: 75%;
    margin: auto;
  }

  .content {
    display: block;
  }

  #component-wrapper {
    padding-top: 32px;
    max-width: 830px;
    &::v-deep {
      .groups h1,
      .users h1 {
        border: none;
      }
    }
  }

  .organization-menu-nav {
    min-width: 190px;
    .sidemenu {
      min-width: 200px;
    }
  }
  ::v-deep .el-menu--horizontal {
    .el-menu-item {
      color: inherit;
      height: 48px !important;
      margin-right: 30px;
      span {
        min-width: 140px;
        font-size: 16px;
        text-align: center;
      }
      .is-active span {
        color: #007eff !important;
      }
    }
    // .el-menu-item:hover {
    //   background-color: RGB(71, 141, 255);
    // }
    .el-menu-item.is-active {
      border-bottom: none;
    }
  }
  .el-menu.sidemenu {
    .el-menu-item {
      text-transform: none;
    }
  }
</style>
